import { Component, Input, OnInit } from '@angular/core';
import { SolarConfigModel } from '../../../models/solar-configuration.model';
import { PlantServiceService } from '../../../services/dashboard/solar/plant-service.service';

@Component({
  selector: 'app-project-info',
  templateUrl: './project-info.component.html',
  styleUrls: ['./project-info.component.scss']
})
export class ProjectInfoComponent implements OnInit {
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('site-id') siteId: string;
  solarConfig: SolarConfigModel;
  sensorHealthMsg: string;
  sensorHealth: string;
  constructor(private plantService: PlantServiceService) {
    this.solarConfig = new SolarConfigModel();
    this.sensorHealthMsg = '';
    this.sensorHealth = '';
  }

  ngOnInit() {
    // this.plantService.getSolarConfigurationInfo(this.siteId)
    // .subscribe(data => {
    //     Object.assign(this.solarConfig, data);
    //     this.plantService.solarConfigSubject.next(this.solarConfig);
    // });

    this.plantService
      .getSensorHealthBasedOnLevel(this.siteId, 'Dashboard')
      .subscribe((data) => {
        if (data.VeryCritical > 0) {
          this.sensorHealth = 'OFF';
          this.sensorHealthMsg = 'NOT OK';
        } else if (data.Critical > 0) {
          this.sensorHealth = 'NA';
          this.sensorHealthMsg = 'NOT OK';
        } else {
          this.sensorHealth = 'ON';
          this.sensorHealthMsg = 'OK';
        }
      });
  }
}
